import {
  LotteryDrawSchema,
  LotterySchema,
  RetailUnitSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type GetLotteryDrawsParams = Static<typeof GetLotteryDrawsParamsSchema>;
export const GetLotteryDrawsParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'GetLotteryDrawsParamsSchema' }
);

export type GetLotteryDrawsResponse = Static<typeof GetLotteryDrawsResponseSchema>;
export const GetLotteryDrawsResponseSchema = Type.Object(
  {
    lotteryDraws: Type.Array(LotteryDrawSchema),
  },
  { additionalProperties: false, $id: 'GetLotteryDrawsResponseSchema' }
);
